
<template>
  <div class="form-group">
    <CountriesCheckboxSelect v-if="selectModels"
                             :object="object"
                             field="countries"
                             :countries="selectModels.countries || []"
                             :label="$t('countries')"/>
  </div>
</template>

<script setup>
import CountriesCheckboxSelect from "@/components/parts/datatable/form/superadmin/CountriesCheckboxSelect.vue"

defineProps({
  object: {},
  selectModels: {
    type: Object
  },
  options: {}
})
</script>
